import moment from 'moment';
import { constants } from 'src/app/common/constants';
import { AgeValidation, RegionIdType } from 'src/app/common/types';

const isValidHkId = (hkId: string | undefined): boolean => {
  if (!hkId || hkId.length < 8 || hkId.length > 9) {
    return false;
  }
  const lsValidChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  const matches = new RegExp(/^[A-Z]{1,2}/).exec(hkId);

  if (matches?.length === 1) {
    const charPart = matches[0];
    const numPart = hkId.slice(charPart.length, -1);
    const checkDigit = hkId.charAt(hkId.length - 1);

    if (/^[\d]+$/.test(numPart)) {
      let checkSum: number;

      if (charPart.length == 1) {
        checkSum = 9 * 36 + 8 * (10 + lsValidChars.indexOf(charPart));
      } else {
        checkSum =
          9 * (10 + lsValidChars.indexOf(charPart.charAt(0))) + 8 * (10 + lsValidChars.indexOf(charPart.charAt(1)));
      }

      for (let i = 0, j = 7; i < numPart.length; i++, j--) {
        checkSum += j * parseInt(numPart.charAt(i));
      }

      const remaining = checkSum % 11;

      let calCheckDigit: string;

      switch (remaining) {
        case 0: {
          calCheckDigit = '0';
          break;
        }
        case 1: {
          calCheckDigit = 'A';
          break;
        }
        default: {
          calCheckDigit = (11 - remaining).toString();
          break;
        }
      }

      return checkDigit == calCheckDigit;
    }
    return false;
  }
  return false;
};

export const createIdentityDocumentValidator =
  (rule?: RegionIdType) =>
  (value: unknown): boolean => {
    const input = String(value).trim();
    if (!rule) {
      return true;
    }

    if (rule.value === 'HKID' && !rule.regex) {
      return isValidHkId(input);
    }

    return rule?.regex ? new RegExp(rule.regex).test(input) : true;
  };

export const createBirthdayValidator = (ageValidation?: AgeValidation | null) => (value: unknown) => {
  const birthday = String(value);

  const birthDate = moment(birthday, constants.Default_Date_Format, true);

  if (!birthDate.isValid()) {
    return {
      valid: false,
      message: 'Common.invalid_date',
    };
  }

  const now = moment();

  if (ageValidation?.min) {
    const maxBirthDate = now.clone().subtract(ageValidation.min.value, 'years');

    if (birthDate.isAfter(maxBirthDate)) {
      return {
        valid: false,
        message: ageValidation.min.errorMessage,
        messageParams: {
          age: ageValidation.min.value,
        },
      };
    }
  }

  if (ageValidation?.max) {
    const minBirthDate = now.clone().subtract(ageValidation.max.value, 'years');

    if (birthDate.isBefore(minBirthDate)) {
      return {
        valid: false,
        message: ageValidation.max.errorMessage,
        messageParams: {
          age: ageValidation.max.value,
        },
      };
    }
  }

  return {
    valid: true,
  };
};
